// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ep-banner[data-v-78df53df]{position:relative;min-width:1200px}@media (max-width:750px){.ep-banner[data-v-78df53df]{width:100vw;min-width:0}}", ""]);
// Exports
module.exports = exports;
